"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return ["word", "wordt", "worden", "werd", "werden", "wordend"];
};